import { render, staticRenderFns } from "./ReferenceFilterComments.vue?vue&type=template&id=15e3ecae&"
import script from "./ReferenceFilterComments.vue?vue&type=script&lang=js&"
export * from "./ReferenceFilterComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports